"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var AppsApi = function (_BaseApi) {
  (0, _inherits2["default"])(AppsApi, _BaseApi);

  function AppsApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, AppsApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AppsApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getApps", function () {
      return _this.api.get('/apps', {
        withoutAuth: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserApps", function (_ref) {
      var userId = _ref.userId,
          clientId = _ref.clientId,
          token = _ref.token;
      return _this.api.get("/users/".concat(userId, "/apps"), {
        withoutAuth: true,
        params: {
          clientId: clientId
        },
        headers: token ? {
          Authorization: token
        } : {}
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "pullAppsByUserId", function (_ref2) {
      var userId = _ref2.userId,
          startAt = _ref2.startAt,
          appName = _ref2.appName,
          clientId = _ref2.clientId;
      return _this.api.get("/apps/".concat(userId), {
        fullResponse: true,
        params: {
          startAt: startAt,
          appName: appName,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkTransaction", function (_ref3) {
      var transactionId = _ref3.transactionId;
      return _this.api.get("/apps/pull/".concat(transactionId, "/result"), {
        withoutAuth: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAppPairingLink", function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(_ref5) {
        var appName, authorization, baseUrl, successUrl, errorUrl, clientId, route, url, callbackSuccess, callbackError, qs;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                appName = _ref5.appName, authorization = _ref5.authorization, baseUrl = _ref5.baseUrl, successUrl = _ref5.successUrl, errorUrl = _ref5.errorUrl, clientId = _ref5.clientId;
                route = "/apps/".concat(appName, "/auth");
                url = "".concat(baseUrl).concat(route);
                callbackSuccess = encodeURIComponent(successUrl);
                callbackError = encodeURIComponent(errorUrl);
                qs = "".concat("authorization=".concat(encodeURIComponent(authorization)), "&callbackError=", callbackError, "&callbackSuccess=").concat(callbackSuccess);
                return _context.abrupt("return", "".concat(url, "?").concat(qs, "&clientId=").concat(clientId));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAppPairingRedirectUrl", function () {
      var _ref6 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(_ref7) {
        var appName, successUrl, errorUrl, clientId;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                appName = _ref7.appName, successUrl = _ref7.successUrl, errorUrl = _ref7.errorUrl, clientId = _ref7.clientId;
                return _context2.abrupt("return", _this.api.get("/apps/".concat(appName, "/auth"), {
                  params: {
                    clientId: clientId,
                    callbackSuccess: successUrl,
                    callbackError: errorUrl,
                    redirect: false
                  }
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteUserApp", function (_ref8) {
      var appName = _ref8.appName,
          userId = _ref8.userId;
      return _this.api["delete"]("/users/".concat(userId, "/apps/").concat(appName));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createUserApp", function (_ref9) {
      var appName = _ref9.appName,
          userId = _ref9.userId;
      return _this.api.post("/users/".concat(userId, "/apps/").concat(appName));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUserApp", function (_ref10) {
      var appName = _ref10.appName,
          userId = _ref10.userId,
          update = _ref10.update;
      return _this.api.put("/users/".concat(userId, "/apps/").concat(appName), {
        data: {
          update: update
        }
      });
    });
    return _this;
  }

  return AppsApi;
}(_createApi.BaseApi);

var _default = AppsApi;
exports["default"] = _default;
//# sourceMappingURL=apps.js.map